module.exports = "/images/icon-share.svg?07667e2824c670f27250b7944814f7bd";